export class ReminderFrequency {
  id: number;
  name: string;
}

export const reminderFrequencies: ReminderFrequency[] = [
  {
    id: 0,
    name: 'Daily',
  },
  {
    id: 1,
    name: 'Weekly',
  },
  {
    id: 2,
    name: 'Monthly',
  },
  {
    id: 3,
    name: 'Quarterly',
  },
  {
    id: 4,
    name: 'Half Yearly',
  },
  {
    id: 5,
    name: 'Yearly',
  },
];
